<template>
    <v-row>
        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.code" :label="$t('delivery.coupon.labels.code')" icon="short_text"/>
                 <show-field :value="String(item.discountValue)" :label="$t('delivery.coupon.labels.discountValue')" icon="payments"/>
                 <show-field :value="getDateFormat(item.expirationDate)" :label="$t('delivery.coupon.labels.expirationDate')" icon="event"/>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.description" :label="$t('delivery.coupon.labels.description')" icon="text_ad"/>
                 <show-field :value="String(item.minimumOrderAmount)" :label="$t('delivery.coupon.labels.minimumOrderAmount')" icon="mintmark"/>
                 <show-field :value="String(item.maxTotalUses)" :label="$t('delivery.coupon.labels.maxTotalUses')" icon="numbers"/>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.discountType" :label="$t('delivery.coupon.labels.discountType')" icon="ink_marker"/>
                 <show-field :value="getDateFormat(item.startDate)" :label="$t('delivery.coupon.labels.startDate')" icon="event"/>
                 <show-field :value="String(item.active)" :label="$t('delivery.coupon.labels.active')" icon="flash_on"/>
            </v-list>
        </v-col>

    </v-row>
</template>
<script>
    import {ShowField} from '@dracul/common-frontend'
    import {DayjsMixin} from "@dracul/dayjs-frontend"; 
    
    export default {
        name: 'CouponShowData',
        components: {ShowField},
        mixins: [DayjsMixin],
        props: {
            item: {type: Object, required: true}
        }
    }
</script>

